import React from 'react';
import { graphql, Link, withPrefix } from 'gatsby';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser';


import Layout from '../components/layout';
import Footer from '../components/footer';

import titleSingtel from '../images/title-singtel.svg';
import parseYoastHead from '../utils/YoastParser';

const PageTemplate = ({ content, acf }) => {

  return (
    <main className="template-homepage">
      { acf.hero.image.localFile.publicURL &&
        <section className="hero-5g">
          <div className="hero-image-wrapper" data-sal="slide-up" style={{backgroundImage: `url(${acf.hero.image.localFile.publicURL})`}}>
            <div className="hero-title" data-sal="slide-up">
              <div className="title"> <img src={titleSingtel} alt="title-singtel"/> </div>
            </div>
          </div>
        </section>
      }

      {content && (
        <section className="common-content">
          <div className="container">
            <div className="content-wrapper" data-sal="slide-up">
              {parse(content)}
            </div>
          </div>
        </section>
      )}

      { acf.chairmanMessage.message &&
        <section className="chairman-message">
          <div className="container">
            <div className="w-full md:w-4/5 lg:w-8/12 mx-auto" data-sal="slide-up">
              <div className="title">Chairman and GCEO Message</div>

              <div className="message">
                <div className="open-quote"/>
                <p>{acf.chairmanMessage.message}</p>
                <div className="close-quote"/>
              </div>

              { acf.chairmanMessage.link.uri &&
                <Link to={acf.chairmanMessage.link.uri} className="link">
                  <div className="text-red-100 font-bold text-md lg:text-md2 mr-5"> Read more </div>
                  <div> <img src={withPrefix('/images/icons/caret-right-fill.svg')} alt="caret" /> </div>
                </Link>
              }
            </div>
          </div>
        </section>
      }

      { acf.strategicReset &&
        <section className="strategic-reset">
          <div className="container md:w-4/5 lg:w-full 2xl:w-8/12" data-sal="slide-up">
            <div className="mx-auto w-full lg:w-8/12">
              <div className="title">
                { acf.strategicReset.title }
              </div>

              <div className="description">
                { acf.strategicReset.description }
              </div>
            </div>

            <div className="subtitle">
              { acf.strategicReset.subtitle }
            </div>

            { acf.strategicReset.icons &&
              <div className="icons-wrapper">
                { acf.strategicReset.icons.map((icon, key) => (
                    <div key={key} className="icon">
                      <div className="img-wrapper">
                        <img src={icon.image.localFile.publicURL}/>
                      </div>

                      <div className="icon-title">{icon.title}</div>
                    </div>
                  ))
                }
              </div>
            }

            { acf.strategicReset.link.uri &&
              <Link to={acf.strategicReset.link.uri} className="link">
                <div className="text-red-100 font-bold text-md lg:text-md2 mr-5"> Read more </div>
                <div> <img src={withPrefix('/images/icons/caret-right-fill.svg')} alt="caret" /> </div>
              </Link>
            }
          </div>
        </section>
      }

      { acf.imageBlock &&
        <section className="image-block">
          { acf.imageBlock.map((image, key) => (
              <Link to={image.link.uri} key={key} className="image-link" data-sal="slide-up">
                <div className="image-container">
                  <div className="image-wrapper hidden md:block" style={{backgroundImage: `url(${image.image.localFile.publicURL})`}} />
                  { image.mobileImage &&
                    <img src={image.mobileImage.localFile.publicURL} className="block md:hidden"/>
                  }

                  <div className="details-wrapper">
                    <div className="title"> {image.title} </div>

                    <Link to={image.link.uri} className="link">
                      <div className="text-white font-bold text-md lg:text-md2 mr-5"> Read more </div>
                      <div> <img src={withPrefix('/images/icons/caret-right-fill.svg')} alt="caret" /> </div>
                    </Link>
                  </div>
                </div>
              </Link>
            ))
          }
        </section>
      }
    </main>
  );
};

const PageHomepage = ({data}) => {
  const { wpPage: page } = data;

  let tplAcf;
  if ( page.template.tplHompage ) {
    tplAcf = page.template.tplHompage;
  }

  const yoast = parseYoastHead(page.seo.fullHead);

  return (
    <Layout pageId={page.id} >
      {
        yoast && (
          <Helmet>
            <title>{yoast.title}</title>
            {
              yoast.metas.length > 0 &&
              yoast.metas.map((meta, i) => {
                if (meta.name) {
                  return <meta key={i} name={meta.name} content={meta.content} />;
                } else if (meta.property) {
                  return <meta key={i} property={meta.property} content={meta.content} />;
                }
              })
            }
          </Helmet>
        )
      }

      <PageTemplate content={page.content} acf={tplAcf}/>

      <Footer commonPage={page.commonPage} />
    </Layout>
  );
};

export default PageHomepage;

export const pageQuery = graphql`
  query ($id: String!) {
    wpPage(id: { eq: $id }) {
      content
      commonPage {
        titleOverwrite
        previousPage {
          ... on WpPage {
            title
            uri
          }
        }
        nextPage {
          ... on WpPage {
            title
            uri
          }
        }
      }
      template {
        ... on WpTemplate_Homepage {
          tplHompage {
            hero {
              title
              image {
                localFile {
                  publicURL
                }
              }
            }
            chairmanMessage {
              message
              link {
                ... on WpPage {
                  uri
                }
              }
            }
            strategicReset {
              title
              description
              subtitle
              icons {
                image {
                  localFile {
                    publicURL
                  }
                }
                title
              }
              link {
                ... on WpPage {
                  id
                  uri
                }
              }
            }
            imageBlock {
              title
              image {
                localFile {
                  publicURL
                }
              }
              mobileImage {
                localFile {
                  publicURL
                }
              }
              link {
                ... on WpPage {
                  uri
                }
              }
            }
          }
        }
      }
      seo {
        fullHead
      }
    }
  }
`;
